module.exports = __webpack_public_path__ + "img/pragmago.8ed66ef.png";